import { createSelector } from '@reduxjs/toolkit';

const baseSelector = (state) => state.creditManagement;

export const learnerEmailSelector = createSelector(
  (state) => baseSelector(state).learnerEmail,
  (learnerEmail) => learnerEmail
);

export const creditCountSelector = createSelector(
  (state) => baseSelector(state).creditCount,
  (creditCount) => creditCount
);

export const reasonSelector = createSelector(
  (state) => baseSelector(state).reason,
  (reason) => reason
);

export const isConfirmModalOpenSelector = createSelector(
  (state) => baseSelector(state).isConfirmModalOpen,
  (isConfirmModalOpen) => isConfirmModalOpen
);

export const fieldErrorsSelector = createSelector(
  (state) => baseSelector(state).fieldErrors,
  (fieldErrors) => fieldErrors
);

export const transactionTypeSelector = createSelector(
  (state) => baseSelector(state).transactionType,
  (transactionType) => transactionType
);

export const otherReasonInputSelector = createSelector(
  (state) => baseSelector(state).otherReasonInput,
  (otherReasonInput) => otherReasonInput
);
